"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORWARD_ERROR_MESSAGES = void 0;
const globalErrorCode_1 = require("../../../global/model/error/globalErrorCode");
const globalErrorMessages_1 = require("../../../global/model/error/globalErrorMessages");
const FORWARD_ERROR_MESSAGES = {};
exports.FORWARD_ERROR_MESSAGES = FORWARD_ERROR_MESSAGES;
FORWARD_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN] =
    globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN];
FORWARD_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE] =
    globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE];
//# sourceMappingURL=forwardErrorMessages.js.map